import React from 'react';
import { Sun, Shield, Check } from 'lucide-react';

const VendorHighlights = ({ vendor, services }) => {
  const highlights = [];

  const hasOutdoorServices = services.some(
    (s) =>
      s.service_name?.toLowerCase().includes('outdoor') ||
      s.description?.toLowerCase().includes('outdoor')
  );

  if (hasOutdoorServices || vendor?.years_experience) {
    highlights.push({
      icon: Sun,
      title: vendor?.years_experience
        ? `${vendor.years_experience}+ years experience`
        : 'Outdoor events',
      description: 'Professional service with proven track record',
    });
  }

  if (vendor?.is_verified) {
    highlights.push({
      icon: Shield,
      title: 'Verified vendor',
      description: 'Identity verified by VendaList',
    });
  }

  if (services.length > 0) {
    highlights.push({
      icon: Check,
      title: 'Multiple services available',
      description: `Choose from ${services.length} service options`,
    });
  }

  if (highlights.length === 0) {
    return null;
  }

  return (
    <div className="space-y-3">
      {highlights.map((highlight, index) => {
        const Icon = highlight.icon;
        const isLast = index === highlights.length - 1;
        return (
          <div key={index}>
            <div className="flex items-start gap-3">
              <div className="mt-0.5 shrink-0">
                <div
                  className={`flex items-center justify-center ${
                    highlight.icon === Check
                      ? 'h-5 w-5 rounded-md border border-m-border-light bg-m-surface'
                      : 'h-6 w-6 rounded-md bg-m-ink'
                  }`}
                >
                  {highlight.icon === Check ? (
                    <Icon className="h-3 w-3 text-m-ink" strokeWidth={2.5} fill="none" />
                  ) : (
                    <Icon className="h-3.5 w-3.5 text-white" strokeWidth={2} />
                  )}
                </div>
              </div>
              <div className="min-w-0 flex-1">
                <h3 className="text-sm font-medium leading-tight text-m-ink">
                  {highlight.title}
                </h3>
                <p className="mt-0.5 text-xs leading-snug text-m-ink-muted">
                  {highlight.description}
                </p>
              </div>
            </div>
            {!isLast ? <div className="mt-3 h-px bg-m-border-light" /> : null}
          </div>
        );
      })}
    </div>
  );
};

export default VendorHighlights;
